import { ExternalAppIFrame } from "../ExternalAppIFrame/ExternalAppIFrame";

export default function VehicleMasterIndex() {
	const lynkitioServer = import.meta.env.VITE_LYNKIT_IO_REDIRECT_URL;
	const action = "/my-vehicles";

	return (
		<div>
			<ExternalAppIFrame serverURL={lynkitioServer} action={action} />
		</div>
	);
}
